export class DvonnFailure {
    static NOT_PLAYER_PIECE = () => $localize `You must select a piece or a stack of your color.`;
    static EMPTY_STACK = () => $localize `You must select a stack.`;
    static TOO_MANY_NEIGHBORS = () => $localize `This stack cannot be moved because all 6 of its neighbors are occupied. You must select a stack with strictly less than 6 neighbors.`;
    static CANT_REACH_TARGET = () => $localize `This stack cannot move because it could never land on another piece.`;
    static INVALID_MOVE_LENGTH = () => $localize `A stack must always be moved by as many spaces as there are pieces in the stack.`;
    static EMPTY_TARGET_STACK = () => $localize `The stack must land on an occupied space.`;
    static MUST_MOVE_IN_STRAIGHT_LINE = () => $localize `A stack must move in a straight line.`;
}
